import { StreamUIManager } from "../../../../content/stream/js/StreamUIManager";

import template from "../../../../content/stream/html/stream.html";

export default class StreamBase {
  constructor({ container, config, emitter, streamUIData, streamConfig, streamView, pageObserver }) {
    this.container = container;
    this.config = config;
    this.emitter = emitter;
    this.streamUIData = streamUIData;
    this.streamConfig = streamConfig;
    this.pageObserver = pageObserver;
    
    this.uiManager = new StreamUIManager({
      container, emitter, template, config, streamUIData, streamView, streamConfig
    });
    
    this.uiManager.showPoster();
  }
}